import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from '@/lib/zod-search-params';
import { amountSearchParams } from '@/lib/filters/amount-search-params';

export const toInvoiceSearchSchema = commonSearchSchema.extend({
  scope: optionalSearchString(),
  origin: optionalSearchString(),
  companyId: optionalSearchString(),
  commessaId: optionalSearchString(),
  workReportId: optionalSearchString(),
  contractId: optionalSearchString(),
  dateFrom: optionalSearchString(),
  dateTo: optionalSearchString(),
  ...amountSearchParams,
});

/** Old contracts queue links retain compatible filters on the new page. */
export function legacyBillingSearch(search: Record<string, unknown>) {
  return toInvoiceSearchSchema.parse({
    ...search,
    tab: undefined,
    status: undefined,
    show: undefined,
  });
}
